import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'loading-maintenance',
  templateUrl: './loading-maintenance.component.html',
  styleUrls: ['./loading-maintenance.component.scss']
})
export class LoadingMaintenanceComponent implements OnInit {
  @Input() messageType: number = 0;
  constructor() { }

  ngOnInit() {
  }

}
